export type SideMenuAction = "open" | "close";

export function reduceSideMenuOpen(
  _isSideMenuOpen: boolean,
  action: SideMenuAction,
): boolean {
  return action === "open";
}

export function closeSideMenuOnUnmount(closeSideMenu: () => void): void {
  closeSideMenu();
}
